"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useListenForTransportEvent = exports.useToast = void 0;

var _reactProvider = require("@trycourier/react-provider");

var _react = require("react");

var useToast = function useToast() {
  var _toast$config;

  var courier = (0, _reactProvider.useCourier)();

  var _ref = courier !== null && courier !== void 0 ? courier : {},
      toast = _ref.toast,
      clientKey = _ref.clientKey;

  var toastCaller = toast !== null && toast !== void 0 && toast.toast ? toast.toast : function () {};
  return [toastCaller, {
    config: (_toast$config = toast === null || toast === void 0 ? void 0 : toast.config) !== null && _toast$config !== void 0 ? _toast$config : {},
    clientKey: clientKey
  }];
};

exports.useToast = useToast;

var useListenForTransportEvent = function useListenForTransportEvent(_ref2) {
  var transport = _ref2.transport,
      handleToast = _ref2.handleToast;
  (0, _react.useEffect)(function () {
    if (!transport) {
      return;
    }

    transport.listen({
      id: "toast-listener",
      type: "message",
      listener: function listener(courierEvent) {
        handleToast(courierEvent === null || courierEvent === void 0 ? void 0 : courierEvent.data);
      }
    });
  }, [handleToast, transport]);
};

exports.useListenForTransportEvent = useListenForTransportEvent;